export const isStringWithNumber = (value: string | number | null | undefined): boolean => {
  if (value == null) return false;

  if (typeof value === "number") {
    return !Number.isNaN(value) && Number.isFinite(value) && value >= 0;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") return false;

    const num = Number(trimmed);
    return !Number.isNaN(num) && Number.isFinite(num) && num >= 0;
  }

  return false;
};
